<template>
  <div class="w-100" >

    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      tooltip="Agregar Tipo Recargo"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      @click.native="actionSetShowModalRecargoType(true)"
    />
    <ui-modal
      ref="modal"
      title="Agregar Tipo Recargo"
      transition="scale-up"
      size="large"
      @close="closeModalEvent()"
    >
      <recargos-form-type 
        :closeModal="cerrarModal"
      />
    </ui-modal>
  </div>
</template>

<script>
// Common
import { mapActions,mapState } from "vuex";

import Button from "../../../../common/Button";
import RecargosFormType from "./RecargosFormType";

export default {
  
  props:[],

  data() {
    return {

    };
  },
  methods: {

      ...mapActions(["ActionSetZindexTablaModal"]),
      ...mapActions("lineas", ['actionSetShowModalRecargoType']),
  
      openModal(ref) {
          this.ActionSetZindexTablaModal(true);
          this.$refs[ref].open();
      },
      closeModal(ref) {
          this.$refs[ref].close();
      },
      cerrarModal(){
        this.closeModal("modal");
        this.actionSetShowModalRecargoType(false);
        this.ActionSetZindexTablaModal(false); 
      },
      closeModalEvent(){
        this.actionSetShowModalRecargoType(false);
        this.ActionSetZindexTablaModal(false); 
      }

  },
  computed: {
      ...mapState("lineas", ["showModalRecargoType"]),
    
  },
  components: {
    Button,
    RecargosFormType
  },

  watch: {
    showModalRecargoType: function (_new) {
          _new && this.openModal("modal");
      },
      
  },
};
</script>

<style>

</style>
